type BadgePros = {
  color?:
    "blue"
    | "green"
    | "red"
    | "yellow"
    | "indigo"
    | "purple"
    | "pink"
    | "gray"
    | "disabled"
    | "stringRed"
    | "stringBlack";
  rounded?: boolean;
  children: React.ReactNode;
  className?: string;
  onClick?: () => void;
};

const style = {
  rounded: "rounded-full",
  colors: {
    blue: "text-blue-800 bg-blue-100",
    green: "text-green-800 bg-green-100",
    red: "text-red-800 bg-red-100",
    yellow: "text-yellow-800 bg-yellow-100",
    indigo: "text-indigo-800 bg-indigo-100",
    purple: "text-purple-800 bg-purple-100",
    pink: "text-pink-800 bg-pink-100",
    gray: "text-gray-800 bg-gray-100",
    disabled: "text-gray-800 bg-gray-100 opacity-30",
    stringRed:"text-red-500 font-extrabold",
    stringBlack: "text-right",
  },
};

const Badge = ({ color="indigo", rounded, children, className, onClick}: BadgePros) => {
  return (
    <>
      <span
        className={`inline-flex items-center px-2.5 py-0.5 m-0.5 text-xs font-medium
        ${style.colors[color]}
        ${rounded ? style.rounded : "rounded-md"}
        ${className ?? ""}`}
        onClick={onClick}
      >
        {children}
      </span>
    </>
  );
};

export default Badge;
